// extracted by mini-css-extract-plugin
export default {"highlight":"wW_Pnjw","highlightIcon":"tVApSH_","highlightColorTile":"b4w1Bsn"};